import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

export const VideoWithLinkStyled = styled.a`
  position: relative;
  display: flex;
  width: ${({ $maxWidth }) => $maxWidth || '100%'};
  border-radius: 1.25rem;
  overflow: hidden;

  @media (max-width: ${breakpoints.screenMD}) {
    width: 100%;
  }

  .play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.backgroundPrimary};
    border-radius: 100%;
    opacity: 0.7;
    width: 85px;
    height: 85px;

    @media (max-width: ${breakpoints.screenSM}) {
      width: 65px;
      height: 65px;
    }
  }

  .icon-play {
    margin-left: 0.65rem;

    @media (max-width: ${breakpoints.screenSM}) {
      max-width: 25px;
    }
  }
`
